// extracted by mini-css-extract-plugin
export default {"title":"FailedToLoad_title__AvzsM","message":"FailedToLoad_message__f2qD0"};